var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-text col-12",class:_vm.customClass,domProps:{"innerHTML":_vm._s(_vm.localized('html'))}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8cd51d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bz-tree/BzText.vue
// module id = 5oOZ
// module chunks = 1